"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkDependencyRequirements = checkDependencyRequirements;
exports.getDependencies = getDependencies;
exports.getExcludingGrantTypes = getExcludingGrantTypes;
exports.getGrantTypeDisabledKey = getGrantTypeDisabledKey;
exports.getGrantTypeValueKey = getGrantTypeValueKey;
exports.mergeGrantTypes = mergeGrantTypes;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getGrantTypeValueKey(name) {
  return "grantTypes.".concat(name, ".value");
}
function getGrantTypeDisabledKey(name) {
  return "grantTypes.".concat(name, ".disabled");
}
function getDependencies(targetGrantType, allGrantTypes) {
  return (targetGrantType.depends || []).reduce(function (acum, dependencyName) {
    var dependency = allGrantTypes.find(function (grantType) {
      return grantType.name === dependencyName;
    });
    if (dependency) {
      acum.push(dependency);
    }
    return acum;
  }, []);
}
function getExcludingGrantTypes(targetGrantType, allGrantTypes, form) {
  return allGrantTypes.filter(function (grantType) {
    var isGrantTypeSelected = form[getGrantTypeValueKey(grantType.name)];
    var isExcludingTargetGrantType = (grantType.exclude || []).some(function (excludedGrantType) {
      return excludedGrantType === targetGrantType.name;
    });
    return isGrantTypeSelected && isExcludingTargetGrantType;
  });
}
function checkDependencyRequirements(targetGrantType, form) {
  var dependencies = targetGrantType.depends || [];
  return !dependencies || dependencies.length === 0 || dependencies.some(function (dependency) {
    return form[getGrantTypeValueKey(dependency)];
  });
}
function mergeGrantTypes(form, allGrantTypes) {
  var newForm = _objectSpread({}, form);
  allGrantTypes.forEach(function ($grantType) {
    // If grantType is required, it will always be 'on' and disabled
    if ($grantType.required) {
      newForm[getGrantTypeValueKey($grantType.name)] = true;
      newForm[getGrantTypeDisabledKey($grantType.name)] = true;
      return;
    }

    // If a grantType is not required, it will be available when:
    //   * It hasn't had dependencies or has at least one dependency 'on' AND
    //   * There isn't any 'on' grantType that is excluding it
    var isDependencyRequirementsOk = checkDependencyRequirements($grantType, newForm);
    var isExcludedByOther = getExcludingGrantTypes($grantType, allGrantTypes, newForm).length > 0;
    if (isDependencyRequirementsOk && !isExcludedByOther) {
      newForm[getGrantTypeDisabledKey($grantType.name)] = false;
    } else {
      newForm[getGrantTypeValueKey($grantType.name)] = false;
      newForm[getGrantTypeDisabledKey($grantType.name)] = true;
    }
  });
  return newForm;
}
//# sourceMappingURL=utils.js.map